const FALLBACK_FAVICON = '/logos/favicon_midnightblue.svg';

const FAVICON_BY_THEME = {
  midnightblue: '/logos/favicon_midnightblue.svg',
  skyblue: '/logos/favicon_skyblue.svg',
  sage: '/logos/favicon_sage.svg',
  forestgreen: '/logos/favicon_forestgreen.svg',
  wisteria: '/logos/favicon_wisteria.svg',
  aubergine: '/logos/favicon_aubergine.svg',
};

const ensureIconLink = (rel = 'icon') => {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    if (rel === 'icon') link.setAttribute('type', 'image/svg+xml');
    document.head.appendChild(link);
  }
  return link;
};

export const applyThemeFavicon = (theme) => {
  if (typeof document === 'undefined') return;
  const href = FAVICON_BY_THEME[String(theme || '').trim()] || FALLBACK_FAVICON;
  const icon = ensureIconLink('icon');
  if (icon.getAttribute('href') !== href) {
    icon.setAttribute('href', href);
  }
};

